import React, { Fragment } from "react";
import { HeaderTracking } from "./componentsLanding/HeaderTracking";
import { HeroTracking } from "./componentsLanding/HeroTracking";

export const LandingTracking = () => {
  return (
    <Fragment>
      <HeaderTracking></HeaderTracking>
      <HeroTracking></HeroTracking>
    </Fragment>
  );
};
